import isNil from "~/kernel/validation/isNil";
import useViewportSize from "./useViewportSize";
import { isMobile } from "./isMobile";

export default function useIsMobile() {
  const size = useViewportSize();

  if (isNil(size)) {
    return false;
  }

  return isMobile(size);
}
